import { ModulesManagerService } from "../Module/modules-manager.service"

export class AuthToken {
    private id: number = 0
    private userId: number = 0
    private createdDate: number = 0
    private lastUse: number = 0
    private lastIp: string = ""
    private name: string = ""
    private model: string = ""
    private manufacturer: string = ""
    private system: string = ""
    constructor(private manager: ModulesManagerService, Data: any = null) {
        if (Data != null) {
            this.Hydrate(Data)
        }
    }


    async Hydrate(Data, UpdateAnnex = false) {
        // hydrate les setter 
        for (const [propertie, values] of Object.entries(Data))
            this[this.manager.Tool.minimilizeFirstChar(propertie)] = values

    }

    get Id() {
        return this.id
    }

    get UserId() {
        return this.userId
    }

    get CreatedDate() {
        return this.createdDate
    }

    get LastUse() {
        return this.lastUse
    }

    get LastIp() {
        return this.lastIp
    }

    get Name() {
        return this.name
    }

    get Model() {
        return this.model
    }

    get Manufacturer() {
        return this.manufacturer
    }

    get System() {
        return this.system
    }

    get DisplayCreatedDate(){
        return (new Date(this.createdDate))["getFromFormat"](this.manager.Trad.Parse("STR_FULLDATE_SHOW"))
    }

    get DisplayLastUse(){
        return (new Date(this.lastUse))["getFromFormat"](this.manager.Trad.Parse("STR_FULLDATE_SHOW"))
    }

}
